import React, { MouseEvent, useEffect, useState } from 'react';
import styled from 'styled-components';
import Storage = firebase.storage.Storage;

import firebase from '../core/libs/Firebase';
import ContactsSpinner, { ContactsSpinnerContainer } from '../components/ContactsSpinner';
import placeholder from './assets/placeholder.png';
import { DeviceQueries } from '../components/styled';
import { useContactsContext } from '../contexts/ContactsContext';

declare const REACT_APP_STORAGE_BUCKET: string;

const firebasePrefix = 'https://firebasestorage.googleapis.com/';

interface Props {
  className?: string;
  src: string;
  onClick?: (event: MouseEvent) => void;
  showSpinner?: boolean;
  hideOnMobile?: boolean;
}

export default function Image({ className, src, onClick, showSpinner = false, hideOnMobile = false }: Props) {
  const contactsContext = useContactsContext();
  const [url, setUrl] = useState(placeholder);
  const [loading, setLoading] = useState(false);
  const storage: Storage = firebase.storage();

  useEffect(() => {
    let isSubscribed = true;

    (async () => {
      if (src.startsWith(firebasePrefix) && src.indexOf(REACT_APP_STORAGE_BUCKET) > -1) {
        setLoading(true);
        try {
          let url = await contactsContext.getImageUrl(src);
          if (!url) {
            url = await storage.refFromURL(src).getDownloadURL();
          }
          if (url) {
            await contactsContext.setImageUrl(src, url);
          }
          if (isSubscribed) {
            setUrl(url);
            setLoading(false);
          }
        } catch (e) {
          if (isSubscribed) {
            setUrl(placeholder);
            setLoading(false);
          }
        }
      } else {
        setUrl(src ?? placeholder);
      }
    })();

    return function cleanup() {
      isSubscribed = false;
    };
  }, []);

  if (!src) {
    return <UserProfilePhotoMissing $hideOnMobile={hideOnMobile}/>;
  }

  return (<>
    {loading ?
      <UserProfilePhoto as="div" className={className} $hideOnMobile={hideOnMobile}>{showSpinner &&
        <ContactsSpinner/>}</UserProfilePhoto> :
      <UserProfilePhoto $hideOnMobile={hideOnMobile} url={url} className={className} onClick={onClick}/>}
  </>);

}

interface UserProfilePhotoProps {
  url?: string;
  $hideOnMobile: boolean;
}

export const UserProfilePhoto = styled.div`
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 6px;
  border: solid 2px #ffffff;
  float: left;
  align-items: center;
  margin-right: 12px;
  margin-top: 1px;
  background: url(${(props: UserProfilePhotoProps) => props.url}) center / cover no-repeat;

  ${ContactsSpinnerContainer} {
    margin-top: 2px;
  }

  @media (${DeviceQueries.mobile}) {
    display: ${(props: UserProfilePhotoProps) => props.$hideOnMobile ? 'none' : undefined}
  }
`;

export const UserProfilePhotoMissing = styled.div`
  width: 40px;
  height: 42px;
  float: left;
  margin-right: 12px;

  @media (${DeviceQueries.mobile}) {
    display: ${(props: { $hideOnMobile: boolean }) => props.$hideOnMobile ? 'none' : undefined}
  }
`;
